import * as http from '~/utils/apis';

const heroMetaData = {
    getAll: async () => {
        const { data } = await http.get(`cms-api/hero-saga/hero-metadata`);
        return data;
    },
};

export default heroMetaData;
